import AddIcon from '@mui/icons-material/Add';
import { IconButton, Stack, styled, Tooltip, Typography, tooltipClasses } from '@mui/material';

const StyledHeader = styled(Stack)({
  height: '36px',
  lineHeight: '36px',
  borderTop: '1px solid #E0E0E0',
  textTransform: 'uppercase',
});

interface ISubItemHeader {
  count: number;
  onAdd: () => void;
  canAdd: boolean;
}

export function SubItemHeader({ count, onAdd, canAdd }: ISubItemHeader) {
  return (
    <StyledHeader direction="row" alignItems="center" justifyContent="space-between">
      <Typography
        sx={{
          fontSize: '12px',
          lineHeight: '12px',
          fontWeight: '600',
          color: 'text.secondary',
        }}
      >
        {`SUB-ITEMS${count > 0 ? ` (${count})` : ''}`}
      </Typography>
      {count > 0 && canAdd && (
        <Tooltip
          title="Add Sub-Item"
          placement="top-end"
          slotProps={{
            popper: {
              sx: {
                [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
                  {
                    marginBottom: '4px',
                  },
              },
            },
          }}
        >
          <IconButton size="small" aria-label="Sub Items" onClick={onAdd} sx={{ padding: '2px' }}>
            <AddIcon aria-label="add sub-item" fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </StyledHeader>
  );
}
